const holidays = {
  headerButtons: {
    create: 'Crear',
    delete: 'Eliminar',
  },

  table: {
    headers: {
      start: 'Início',
      end: 'Fin',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
  },

  create: {
    successToast: {
      body: 'El feriado se ha añadido correctamente',
    },
    errorModal: {
      header: 'Ocurrió un error',
      body: 'No se pudo crear el feriado',
    },
  },
  delete: {
    successToast: {
      body: 'El feriado se ha eliminado correctamente',
    },
    errorToast: {
      body: 'No se pudo crear el feriado',
    },
  },
  edit: {
    errorToast: {
      body: 'No se pudo crear el feriado',
    },
    successToast: {
      body: 'El feriado se ha actualizado correctamente',
    },
    errorModal: {
      header: 'Ocurrió un error',
      body: 'No se pudo actualizar el feriado',
    },
    successModal: {
      header: 'Éxito',
      body: '¡Día festivo actualizado!',
    },
  },

  forms: {
    header: {
      create: {
        title: 'Crear',
      },

      update: {
        title: 'Actualizar',
      },
    },

    details: {
      header: 'Detalles',
      fields: {
        name: 'Nombre',
      },
    },
    dates: {
      header: 'Intervalo de fechas',
      fields: {
        rangeSwitch: 'Intervalo de fechas',
        start: 'Início',
        end: 'Fin',
        date: 'Fecha',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
  },
};

export default holidays;
